import { parseColor as AriaParseColor } from "@react-stately/color";

export function parseColor(color: string) {
  // TODO: add support for rgba colors
  return AriaParseColor(color);
}
